import React from "react";
import style from "./LoginSignup.module.css";
import {
    Box,
    Text,
    Flex,
    Image,
    List,
    ListItem,
    ListIcon,
    CloseButton,
    InputGroup,
    InputLeftAddon,
    Input,
    Button,
    Stack,
    Spinner,
} from "@chakra-ui/react";
import { BsCheck } from "react-icons/bs";
import signupHome from "../../Images/Login/signupHome.png";
import { Link, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginSignupReq } from "../../Redux/LoginSignup/action";
import useCustomNavigate from "../../hooks/useCustomNavigate";
import { loginUser } from "../../services/userService";
import { setUserData } from "../../Utils/localStorageUtils";
import CustomPhoneInput from "../../Components/CustomPhoneInput/CustomPhoneInput";

function Login() {
    const [show, setShow] = React.useState(true);
    const [name, setName] = React.useState("");
    const [mobile, setMobile] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");
    const { goTo } = useCustomNavigate();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(loginSignupReq(true));
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name || !mobile) {
            alert("All fields are required!");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const data = { name, mobile };
            const response = await loginUser(data); // Call the loginUser function

            if (response.success) {
                // Store the user data in localStorage using the utility function
                setUserData(response.user); // Save user data
                goTo("/otp")
            } else {
                setError(response.message || "Something went wrong.");
            }

            console.log("Form Submitted:", response);
        } catch (error) {
            setError(error.response?.data?.message || "An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (!show) {
        dispatch(loginSignupReq(false));
        return <Navigate to="/" />;
    }

    return (
        show && (
            <Box className={style.loginSignupContainer}>
                <Box></Box>
                <Box>
                    <Box h="100%" position="relative">
                        <Box>
                            <CloseButton
                                alignSelf="flex-start"
                                position="absolute"
                                right={4}
                                top={4}
                                onClick={() => goTo("/")}
                            />
                        </Box>

                        <Flex flexDirection="row" w="100%" h="100%">
                            <Flex className={style.loginLeftBox}>
                                <Box ml="10%" alignSelf="flex-start">
                                    <Image
                                        src={signupHome}
                                        alt="home"
                                        h="100px"
                                        w="100px"
                                        minH="84px"
                                    />
                                </Box>
                                <Box mt="10px" maxW="80%" w="80%">
                                    <Text fontWeight="600" fontSize="18px" mb="8px">
                                        Login
                                    </Text>
                                    <List spacing={3}>
                                        <ListItem>
                                            <ListIcon as={BsCheck} color="green.500" />
                                            Zero Brokerage.
                                        </ListItem>
                                        <ListItem>
                                            <ListIcon as={BsCheck} color="green.500" />
                                            Thousands of new listings daily.
                                        </ListItem>
                                        <ListItem>
                                            <ListIcon as={BsCheck} color="green.500" />
                                            100 Cr+ Brokerage saved monthly.
                                        </ListItem>
                                    </List>
                                </Box>
                            </Flex>
                            <Box className={style.loginRightBox}>
                                <Box className={style.loginFormContainer}>
                                    <Text>Enter phone to continue</Text>
                                    <form onSubmit={handleSubmit}>
                                        <Stack mt="20px" mb="20px" spacing={3}>
                                            <Input
                                                type="text"
                                                variant="outline"
                                                placeholder="Name"
                                                name="name"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                className={style.nameAndEmail}
                                                required
                                            />
                                        </Stack>
                                        
                                        <CustomPhoneInput mobile={mobile} onChange={(mobile) => setMobile(mobile)}/>

                                        {error && (
                                            <Text color="red.500" mt="10px">
                                                {error}
                                            </Text>
                                        )}

                                        <Button
                                            type="submit"
                                            className={style.loginButton}
                                            mt="20px"
                                            isLoading={loading} // Show loading spinner on button
                                        >
                                            Continue
                                        </Button>
                                    </form>
                                    <Text fontSize="12px !important" align="center" mt="5px">
                                        Don't have an account?{" "}
                                        <Link to="/signup">
                                            <Text color="blue !important" display="inline">
                                                Sign Up
                                            </Text>
                                        </Link>
                                    </Text>
                                </Box>
                                <Text className={style.loginFooter}>
                                    By continuing, you agree to our{" "}
                                    <a href="#" target="_blank">
                                        Terms & Conditions
                                    </a>
                                </Text>
                            </Box>
                        </Flex>
                    </Box>
                </Box>
            </Box>
        )
    );
}

export default Login;
